export { RewardDetail as default } from 'features/reward/RewardDetail';
